/* eslint-disable camelcase */
/* eslint-disable no-buffer-constructor */
/* eslint-disable prefer-const */
/* eslint-disable no-unneeded-ternary */
import Utf8 from 'crypto-js/enc-utf8';
import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js';
import base64 from 'base-64';
import { inflate, ungzip } from 'pako';
import { TextDecoder } from 'text-encoding';
import { getSecureKeyConfig } from './secureKeyConfig';

/**
 * @description 加密
 * @param {string} data 要加密的数据
 * @param {string} keyStr 加密key
 * @param {string} ivStr 加密Iv
 * @return
 */
export function encryptStringToSn(data) {
  const secureConfig = getSecureKeyConfig({ useDefault: true });
  const sendData = Utf8.parse(data);
  const key = Utf8.parse(secureConfig.privateKey);
  const iv = Utf8.parse(secureConfig.privateIv);
  let encrypted = AES.encrypt(sendData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  let aesDataStr = Utf8.parse(encrypted.toString());
  return CryptoJS.enc.Base64.stringify(aesDataStr);
}

export function decryptString(data) {
  if (!data) {
    return;
  }
  const secureConfig = getSecureKeyConfig({ useDefault: true });
  const key = Utf8.parse(secureConfig.privateKey);
  const iv = Utf8.parse(secureConfig.privateIv);
  let deData = CryptoJS.enc.Base64.parse(data);
  let deStr = Utf8.stringify(deData);
  let decrypt = AES.decrypt(deStr, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  let str = Utf8.stringify(decrypt);
  let result = str.trim();
  return decompressData(result);
}

//base64加密/解密
function commEncode(str, source = 'utf8', cry = 'base64') {
  const encoder = new Buffer(str, source).toString(cry);
  return encoder;
}
//base64加密
export function BASE64_encode(str) {
  // var base64Str = new Buffer( str ).toString('base64');
  return commEncode(str, 'utf8', 'base64');
}
//base64解密
export function BASE64_decode(str) {
  return commEncode(str, 'base64', 'utf8');
}

function getdeBASE64inCodec(s) {
  if (!s) {
    return null;
  }
  try {
    // 清理 Base64 字符串
    const sanitizedString = s.replace(/[^A-Za-z0-9+/=]/g, '');
    const decodedString = base64.decode(sanitizedString);

    // 将解码后的字符串转换为 Uint8Array
    const len = decodedString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = decodedString.charCodeAt(i);
    }
    return bytes;
  } catch (error) {
    console.error('Base64 解码失败:', error);
    throw error;
  }
}

// 解压缩函数
function decompressData(encdata) {
  try {
    const decodedData = getdeBASE64inCodec(encdata);
    if (!decodedData) {
      throw new Error('解码后的数据为空');
    }

    // 根据压缩格式选择解压方法
    // 如果是 GZIP 格式，使用 ungzip；否则使用 inflate
    let decompressedData;
    try {
      decompressedData = ungzip(decodedData);
    } catch (e) {
      console.log('e: ', e);
      // 如果 ungzip 失败，尝试使用 inflate
      decompressedData = inflate(decodedData);
    }

    // 将解压后的数据转换为字符串
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(decompressedData);
  } catch (error) {
    console.error('解压缩失败:', error);
    return '';
  }
}
